import { useState } from 'react';
import Reveal from './Reveal';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-8 md:mb-10">
            <span className="text-xs tracking-[0.3em] text-accent-700 uppercase">FAQ / 常见问答</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">你可能想问的几件事</h2>
          </div>
        </Reveal>

        <div className="flex flex-col gap-3">
          {faqs.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <Reveal key={item.q} delay={idx * 40}>
                <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-medium text-foreground-950">{item.q}</span>
                    <span
                      className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                        isOpen ? 'bg-accent-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'}></i>
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}